import {
  Autocomplete,
  CircularProgress,
  FormControlLabel,
  Switch,
  TextField,
  Typography,
  Popover,
} from "@mui/material";
import { useEffect, useState } from "react";
import { DateRangePicker } from 'react-date-range'; // Changed from rsuite to react-date-range
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { useDispatch, useSelector } from "react-redux";
import {
  setRangePairs,
  setRefIndex,
  setRefFromDate,
  setRefToDate,
  setRefToggle,
  setUploadMaskToggle,
  setValues,
} from "../../reducers/MonitoringSlice";
import ValuesAndRangesComponent from "../Prediction/ValuesAndRangesComponent";
import OptionsForRangeAndValues from "../Prediction/OptionsForRangeAndValues";
import axios from "../../api/axios_client";
import { url } from "../../api/axios_client";
import { toast } from "react-toastify";
import { setMaskingFileContent, setUploaderFlag } from "../../reducers/MapSlice";
import parse from "../../utils/file_to_geojson";
import { formatDateDisplay } from "../../utils/date";

const RefIndexMasking = ({ indexes, refToggle }) => {
  const dispatch = useDispatch();
  const RefIndex = useSelector((state) => state.monitoringState.RefIndex);

  const refFromDate = useSelector((state) => state.monitoringState.refFromDate);
  const refToDate = useSelector((state) => state.monitoringState.refToDate);
  const rangePairs = useSelector((state) => state.monitoringState.rangePairs);
  const values = useSelector((state) => state.monitoringState.values);
  const uploadMaskToggle = useSelector((state) => state.monitoringState.uploadMaskToggle);

  // Add state for date picker popover
  const [datePickerAnchorEl, setDatePickerAnchorEl] = useState(null);
  const datePickerOpen = Boolean(datePickerAnchorEl);
  const datePickerId = datePickerOpen ? 'date-range-popover' : undefined;

  // Get selected reference index name for date range lookup
  const selectedRefIndex = RefIndex[0] ? indexes.find(idx => idx.id === RefIndex[0])?.key : null;

  // Added getDateRange function (same as HistoricalData)
  const getDateRange = (indexName) => {
    if (!indexName) return [];
    try {
      const categories = JSON.parse(localStorage.getItem("categories")) || [];
      const currentIndex = categories.find((category) => category.name.toLowerCase() === indexName.toLowerCase());
      if (currentIndex && currentIndex.available_from && currentIndex.available_to && (currentIndex.available_from !== "None" && currentIndex.available_to !== "None")) {
        // Return dates without time
        const fromDate = new Date(currentIndex.available_from);
        const toDate = new Date(currentIndex.available_to);
        fromDate.setHours(0, 0, 0, 0);
        toDate.setHours(0, 0, 0, 0);
        return [fromDate, toDate];
      }
    } catch (error) {
      console.error("Error parsing categories from localStorage:", error);
    }
    return []; // Return empty array if not found or error occurs
  };

  // Helper function to format state for react-date-range
  const formatRangeForPicker = (fromDate, toDate) => {
    // Check if dates are valid before creating Date objects
    const isValidFromDate = fromDate && !isNaN(new Date(fromDate).getTime());
    const isValidToDate = toDate && !isNaN(new Date(toDate).getTime());

    // Show last available date by default, same as HistoricalData
    const startDate = isValidFromDate ? new Date(fromDate) : (getDateRange(selectedRefIndex)[1] || new Date());
    const endDate = isValidToDate ? new Date(toDate) : (getDateRange(selectedRefIndex)[1] || new Date());

    return [{
      startDate: startDate,
      endDate: endDate,
      key: 'selection'
    }];
  };

  // Helper function to format date range for display
  const formatDisplayDateRange = (fromDate, toDate) => {
    // Check if dates are valid before creating Date objects
    const isValidFromDate = fromDate && !isNaN(new Date(fromDate).getTime());
    const isValidToDate = toDate && !isNaN(new Date(toDate).getTime());

    if (isValidFromDate && isValidToDate) {
      const startDate = new Date(fromDate);
      const endDate = new Date(toDate);
      const startStr = formatDateDisplay(startDate);
      const endStr = formatDateDisplay(endDate);
      return startDate.getTime() === endDate.getTime() ? startStr : `${startStr} - ${endStr}`;
    }
    return "Select Date Range";
  };

  // Popover handlers
  const handleDatePickerClick = (event) => {
    setDatePickerAnchorEl(event.currentTarget);
  };

  const handleDatePickerClose = () => {
    setDatePickerAnchorEl(null);
  };

  // Handle date range change
  const handleRangeChange = (item) => {
    if (!item.selection || !item.selection.startDate || !item.selection.endDate) {
      return;
    }

    const fromDate = new Date(item.selection.startDate);
    const toDate = new Date(item.selection.endDate);

    fromDate.setHours(12, 0, 0, 0);
    toDate.setHours(12, 0, 0, 0);

    dispatch(setRefFromDate(fromDate.toISOString().split("T")[0]));
    dispatch(setRefToDate(toDate.toISOString().split("T")[0]));
  };

  const handleFileChosen = (e) => {
    let file = e.target.files[0];
    if (!file) return;

    // Check if file is tiff/tif
    const ext = file.name.split(".").pop().toLowerCase();
    if (ext === "tiff" || ext === "tif") {
      // Pass the raw file directly
      dispatch(setMaskingFileContent(file));
      dispatch(setUploaderFlag(true));
    } else {
      // Use existing parse function for other file types
      parse(
        file,
        ext,
        function onSuccessCB(res) {
          dispatch(setMaskingFileContent(res));
          dispatch(setUploaderFlag(true));
        },
        function onErrorCB() {
          dispatch(setUploaderFlag(false));
          toast.warn("file content isn't valid");
        }
      );
    }
  };

  const handleToggleMask = () => {
    dispatch(setRefToggle());
  };

  const handleUploadMaskToggle = () => {
    dispatch(setUploadMaskToggle());
  };

  const [options, setoptions] = useState();
  const [loading, setloading] = useState(false);
  useEffect(() => {
    const fetchMeta = async () => {
      console.log(JSON.stringify({ index: RefIndex[0] }));
      if (!RefIndex[0]) return;
      try {
        setloading(true);
        const response = await axios.post(`${url}/categories`, {
          id: RefIndex[0],
        });
        console.log("response of meta", response.data);

        // Get flags and nodata from localStorage categories
        let flags = [];
        let nodata = undefined;

        try {
          const categories = JSON.parse(localStorage.getItem('categories')) || [];
          const currentCategory = categories.find(cat => cat.id === RefIndex[0]);
          if (currentCategory) {
            flags = currentCategory.flags || [];
            nodata = currentCategory.nodata;
            console.log("flags", flags);
            console.log("nodata", nodata);
          }
        } catch (e) {
          console.error("Error getting flags/nodata:", e);
        }

        setoptions({
          ...response.data,
          flags: flags,
          nodata: nodata
        });
      } catch (error) {
        toast.error(error);
      } finally {
        setloading(false);
      }
    };

    fetchMeta();
  }, [RefIndex]);

  return (
    <div className="pred-ref-inner-container">
      <Typography fontWeight={500} fontSize={25}>
        Masking
      </Typography>
      <div>
        <FormControlLabel
          control={
            <Switch
              checked={refToggle}
              onChange={() => handleToggleMask()}
              color="primary" // You can change the color if needed
            />
          }
          label="Masking"
        />
      </div>
      <br />
      {refToggle && (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div style={{ flex: 1, padding: "10px" }}>
            <div>
              <FormControlLabel
                control={
                  <Switch
                    checked={uploadMaskToggle}
                    onChange={() => handleUploadMaskToggle()}
                    color="primary" // You can change the color if needed
                  />
                }
                label="Upload Mask"
              />
            </div>
            {uploadMaskToggle && (<div className="mask-upload-container">
              {/* <span className="search-AOAD">AOAD</span> */}

              <input
                style={{
                  fontSize: "10px",
                }}
                type="file"
                onChange={handleFileChosen}
                accept=".tiff,.tif"
                id="file"
                placeholder=""
                disabled={false}
              />
              {/* <div className="send-container">
      <img src={send} className="send-icon" />
    </div> */}
            </div>)}
            {!uploadMaskToggle && (
              <div>
                <Autocomplete
                  size="small"
                  disablePortal
                  id="combo-box-demo"
                  isOptionEqualToValue={(option, value) => option.name === value.name} // Compare only "name" properties
                  getOptionLabel={(option) => (option ? option.name : "")}
                  onChange={(_, selected) => {
                    if (selected) {
                      console.log("selected", selected);
                      dispatch(setRefIndex([selected.id]));
                    }
                  }}
                  options={indexes || []}
                  sx={{ width: 700 }}
                  renderInput={(params) => <TextField {...params} label="Mask" required />}
                  value={RefIndex[0] ? indexes.find(idx => idx.id === RefIndex[0]) || null : null}
                />
                <br />
                <div>
                  <br />
                  <div style={{ width: "100%" }}>
                    <Typography>Select Range</Typography>
                    <TextField
                      label="Selected Date Range"
                      variant="outlined"
                      fullWidth
                      size="small"
                      margin="normal"
                      aria-describedby={datePickerId}
                      disabled={!selectedRefIndex || getDateRange(selectedRefIndex).length === 0}
                      value={formatDisplayDateRange(refFromDate, refToDate)}
                      onClick={handleDatePickerClick}
                      required
                      InputProps={{
                        readOnly: true, // Make field read-only
                      }}
                      placeholder={selectedRefIndex && getDateRange(selectedRefIndex).length > 0 ?
                        `Available: ${formatDateDisplay(getDateRange(selectedRefIndex)[0])} - ${formatDateDisplay(getDateRange(selectedRefIndex)[1])}` :
                        "Select a mask index first"
                      }
                    />
                    <Popover
                      id={datePickerId}
                      open={datePickerOpen}
                      anchorEl={datePickerAnchorEl}
                      onClose={handleDatePickerClose}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                      }}
                    >
                      <DateRangePicker
                        staticRanges={[]} // Hide predefined ranges sidebar
                        ranges={formatRangeForPicker(refFromDate, refToDate)}
                        onChange={handleRangeChange}
                        showSelectionPreview={true}
                        moveRangeOnFirstSelection={false}
                        months={1} // Show one month
                        direction="horizontal"
                        editableDateInputs={false} // Hide manual input fields
                        minDate={getDateRange(selectedRefIndex)[0] || undefined}
                        maxDate={getDateRange(selectedRefIndex)[1] || undefined}
                      />
                    </Popover>
                    {!selectedRefIndex && (
                      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', marginTop: '4px' }}>
                        Please select a mask index first to enable date selection.
                      </Typography>
                    )}
                  </div>
                </div>
              </div>)}
            <br />
            <br />
            <ValuesAndRangesComponent
              rangePairs={rangePairs}
              setRangePairs={setRangePairs}
              setValues={setValues}
              values={values}
              options={options}
            />
            <br />
          </div>
          <div style={{ flex: 1, padding: "20px" }}>
            {loading ? (
              <CircularProgress />
            ) : (
              options &&
              (<div>
                <Typography fontWeight={500}>{options.unit ?? ""}</Typography>
                <OptionsForRangeAndValues data={options} />
              </div>)
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default RefIndexMasking;
